import * as $ from 'jquery';
import 'bootstrap';

export class timaticWidget {

  initializeWidget(): any {
    if ((/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
      $('body').css("min-height", "100%");
      $('body').css("height", "");
      $('.container--main-header').css("position", "sticky");
      $('.container--main-header').css("top", "0");
    }
    let heading = $('#iata-timatic-widget').attr('data-button-text');
    let buttonText = $('#iata-timatic-widget').attr('data-widget-heading');
    let headingDescription = $('#iata-timatic-widget').attr('data-widget-heading-description');
    let headingTravel = $('#iata-timatic-widget').attr('data-widget-heading-travel');
    let importantText = $('#iata-timatic-widget').attr('data-widget-important');
    $('.iata-widget-button span').html(heading);
    $('.iata-widget-button').css('display', 'block');
    $('.iata-widget__heading').html(buttonText);
    $('.iata-widget__heading').css('display', 'block');
    $("#iata-timatic-widget :input:not(:hidden):not(.p-autocomplete-dropdown)").each(function (index: any) {
      $(this).attr('tabindex', index + 1);
    });
    
    $( "<div class='iata-widget__heading-description'>"+ headingDescription +"</div>" ).insertAfter( ".p-panel-header" );
    $("<div class='iata-widget__heading-travel'>"+ headingTravel +"</div>").insertAfter(".iata-widget__heading-description");
    $("<div class='iata-widget__important'>"+ importantText +"</div>").insertBefore(".iata-widget__footer");

    let iElement = $( ".iata-widget__footer" ).find( "i" );
    let sElement = $( ".iata-widget__footer" ).find( ".iata-widget-terms" );
    $(iElement).remove();
    $(sElement).remove();
    $('<span class="iata-widget-terms-new">Powered by © IATA Netherlands BV 2022 all rights reserved. Usage subject to <a href="https://www.timaticweb2.com/userterms" target="_blank" rel="noopener">Terms of Use</a></span>').insertAfter('.iata-widget-logo');

    $('.iata-widget-button').click(function() {
      setTimeout(() => {
        $('.iata-widget__destination-title ').css('display', 'none');
        let destination = $('#search-field-1').val();
        let departure = $('#search-field-2').val();
        // let nationality = $('#search-field-3').val();
        // let residency = $('#search-field-4').val();
        let str = "";
        if(departure === "" || departure === null) {
          str = destination;
        } else {
          str = departure + " to " + destination;
        }
        $($('.iata-widget__destination-title ').children()[0]).html(str);
        $('.iata-widget__destination-title ').css('display', 'block');
        // $('<div style="padding: 16px 0px;"><div class="row"><div class="col-sm-6">Nationality</div><div class="col-sm-6">Residence</div></div><div class="row"><div class="col-sm-6">'+nationality+'</div><div class="col-sm-6">'+residency+'</div></div></div>').insertAfter($($($('.iata-widget__main').children()[0]).children())[0]);
      }, 5000);
    });
  }
}

let scope: Element = document.querySelector('#iata-timatic-widget');
if (scope) {
  try {
    let timaticW = new timaticWidget();
    timaticW.initializeWidget();
  } catch (e) { console.error(e); }
}

